module.exports = __webpack_public_path__ + "54adfe14865656b46b1e599a906c0484.png";